import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SysConfigService} from './sys-config.service';
import {DistrictDTO} from '../dto/district.model';
import {ProvinceDTO} from '../dto/province.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class DistrictService {
  districtSearchDetailsChange = new EventEmitter<DistrictDTO[]>();
  private districtSearchDetailsItem: DistrictDTO[] = [];

  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  /** Save District Details **/
  saveDistrictDetails(districtDTO: DistrictDTO){
    return this.httpClient.post(this.BASE_URL + 'district/save' , districtDTO,{responseType: 'text'});
  }

  /** Get all district details **/
  getAllDistricts() {
    return this.httpClient.get(this.BASE_URL + 'district/all');
  }

  /** Search district details **/
  searchDistrictDetails(districtDTO: DistrictDTO){
    return this.httpClient.post(this.BASE_URL + 'district/search', districtDTO, { headers: this.headers });
  }

  /** Delete district details **/
  deleteDistrictDetails(code: string) {
    return this.httpClient.delete(this.BASE_URL + 'district/delete/'+code, { headers: this.headers });
  }

  /** reset searched details **/
  clearProvinceSearchDetails() {
    this.districtSearchDetailsItem = [];
    this.districtSearchDetailsChange.emit(this.districtSearchDetailsItem);
  }

  /** set search details in the table **/
  setProvinceSearchDetails(districtDetails: DistrictDTO[]) {
    this.districtSearchDetailsItem = districtDetails;
    this.districtSearchDetailsChange.emit(this.districtSearchDetailsItem);
  }
}
